import { useTableColumns } from '@/creditflowresearch/ui/components/deals/DealListTable/columns/ABSIssueColumns';
import LoadMore from '@/creditflowresearch/ui/components/deals/DealListTable/components/LoadMore/LoadMore';
import DealData from '@/creditflowresearch/ui/components/deals/DealListTable/components/DealData';
import GenericTable, {
  IGenericTableProps,
} from '@/creditflowresearch/ui/components/deals/DealListTable/components/GenericDealListTable';
import { useDealTooltipContext } from '@/creditflowresearch/application/Deal/contexts/DealTooltipContext';
import { useAbsContext } from '@/creditflowresearch/application/Deal/contexts/IssueTile/AbsContext';
import { useRowsExpandedContext } from '@/creditflowresearch/application/Deal/contexts/RowsExpandedContext';
import { useIsGuest } from '@/creditflowresearch/application/User/access';
import LoginOrSignUpPopover from '@/creditflowresearch/ui/common/components/LoginOrSignUpPopover';

export const AbsDealsTable = ({
  showDealDetailsByDefault, ...props
}: Partial<IGenericTableProps<any>> & { showDealDetailsByDefault?: boolean }) => {
  const { collection, totalCount, isFetching, loadMore } = useAbsContext();

  const isGuest = useIsGuest();

  const { isRowsExpanded } = useRowsExpandedContext();

  const { onClick } = useDealTooltipContext();

  const columns = useTableColumns();

  return (
    <GenericTable
      columns={ columns }
      collection={ collection }
      isRowsExpanded={ isRowsExpanded }
      expandableRowContent={
        (rowData) => (
          <DealData { ...rowData } showDealDetailsByDefault={ showDealDetailsByDefault } isRestricted={ isGuest } />
        )
      }
      isFetching={ isFetching }
      expandableComponent={ (
        <LoginOrSignUpPopover isRestricted={ isGuest } placement="bottom" isBlockLevelTrigger>
          <LoadMore collection={ collection } totalCount={ totalCount } loadMore={ loadMore } disabled={ isGuest } />
        </LoginOrSignUpPopover>
      ) }
      dataTest="dealsList"
      onRowClick={ (event, params) => onClick(event, params.row.id) }
      { ...props }
    />
  );
};

export default AbsDealsTable;
